<app-form-viewer *ngIf="!isLoading && formTitle; else loader" [readOnly]="readOnly" [formFields]="form"
  [model]="formData" (save)="onSave($event)" [formTitle]="formTitle" [typeForm]="typeForm">
</app-form-viewer>

<ng-template #loader>
  <div style="width: 100%; height: 50vh; display:flex;">
    <app-loader style="text-align: center;">
      <h3>{{ loadingMessage }}</h3>
    </app-loader>
  </div>
</ng-template>